<template>
    <div class="dragBusinessUnit" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}">
        <div class="label">
            {{ appendedData.label }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'dragBusinessUnit',
        data(){
            return{
                toggled: false,
                posx: 0,
                posy: 0,
                appendedData: {},
                callbackEnd: function(){},
                htmlContent: '',
                closest: {},
                parent: null,
            }
        },
        created () {
            var view = this;
            requestAnimationFrame(function(){
                $(view.$el).appendTo('body');
            });
        },
        methods: {
            DragStart(parent, posx, posy, appendedData,indexGroup){
                this.parent = parent;
                document.addEventListener('mousemove', this.DragUpdate);
                document.addEventListener('mouseup', this.DragEnd);
                this.appendedData = appendedData;
                this.posx = posx - 10;
                this.posy = posy - 10;
                this.toggled = true;
                $(this.$el).find('.extra').html('');
                if(this.htmlContent)
                {
                    $(this.htmlContent).appendTo($(this.$el).find('.extra'));
                }
                this.parent.dropIndexBusinessUnit = (parseInt(indexGroup)%2) == 0 ? parseInt(indexGroup) : parseInt(indexGroup)+1 ;
            },
            DragUpdate($event){
                this.posx = $event.pageX - 10;
                this.posy = $event.pageY - 10;
                var elements = $(window.mouse.element).closest('.h-employee-groups');
                if(elements.length && elements.length > 0){
                    this.closest = elements[0];

                    let closestIndex = this.closest.getAttribute("groupindex");
                    if(this.$parent.employeeGroups[parseInt(closestIndex)].helper == true){
                        this.parent.dropIndexBusinessUnit = parseInt(closestIndex);
                    }else{
                        //If not a helper, then search for the next helper
                        let cl = closestIndex;
                        do{
                            if(this.$parent.employeeGroups[parseInt(cl)].helper == true){
                                this.parent.dropIndexBusinessUnit = parseInt(cl);
                                break;
                            }
                            cl++;
                        }while(cl < 100);
                    }
                }

            },
            DragEnd(){
                this.toggled = false;
                document.removeEventListener('mousemove', this.DragUpdate);
                document.removeEventListener('mouseup', this.DragEnd);
                if(this.callbackEnd)
                {
                    this.callbackEnd(this.appendedData,this.closest);
                    this.callbackEnd = null;
                }
            },
        },
        mounted() {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .dragBusinessUnit{
        position:fixed;
        display:flex;
        height: 19px;
        width: 230px;
        background: #6d8d23;
        border-radius: 100px;
        display:none;
        z-index: 1000;
        overflow: hidden;
        pointer-events:none !important;
    }
    .label{
        background-attachment:scroll;
color:rgb(239, 239, 239);
cursor:default;
display:block;
float:left;
font-family:DistrictProBook;
font-size:13px;
font-weight:700;
height:19px;
line-height:19.5px;
margin-bottom:0px;
margin-left:0px;
margin-right:0px;
margin-top:-1px;
opacity:1;
padding-bottom:0px;
padding-left:25px;
padding-right:25px;
padding-top:0px;
text-align:left;
text-size-adjust:100%;
transition-delay:0s;
transition-duration:0.2s;
transition-property:all;
transition-timing-function:ease;
    }
</style>
